export default "__VITE_ASSET__DnxwEDqR__"